<template>
  <div class="d-flex">
    <div class="col-md-3">
      <div class="mt-2" v-if="tabIndex === 0">
        <FilterSeveralContributor @search="search"></FilterSeveralContributor>
      </div>
      <div class="mt-2" v-if="tabIndex === 1">
        <Filtermiscellaneouslots @search="search"></Filtermiscellaneouslots>
      </div>
    </div>
    <div class="col-md-9">
      <b-tabs v-model="tabIndex">
        <b-tab :title="'Colaboradores'">
          <template slot="title">
            <i class="fas fa-user"></i><span class="d-md-down-none pl-1 text-third"> Colaboradores</span>
          </template>
          <tablecollaborator :isConsulta="true" v-if="tabIndex === 0" ref="tablecollaborator"></tablecollaborator>
        </b-tab>
        <b-tab :title="'Lotes Pagos'">
          <template slot="title">
            <i class="fa fa-table"></i><span class="d-md-down-none pl-1 text-third"> Lotes Pagos</span>
          </template>
          <tablepaidlots :isConsulta="true" v-if="tabIndex === 1" ref="diversosLotes"></tablepaidlots>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import MiscellaneousReimbursementConsulta from './miscellaneousreimbursementconsulta'
export default MiscellaneousReimbursementConsulta
</script>

<style scoped>
 .col-md-3{
  padding-right: 0;
  padding-left: 0;
 }
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/miscellaneousreimbursementconsulta.vue